import React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyPlanUpgradeFeatureEnum } from 'graphql-common';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import Trans from '@lib/components/Trans/Trans';
import { IconName } from '@lib/components/Modal/enums';
import { PlanState } from '@lib/enums/plan';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';

export default function HistoryUpgradeRequiredState() {
  const { t } = useTranslation();
  const { handleOpenPlanModal }: ContextProps = useOutletContext();

  return (
    <EmptyState
      icon={IconName.Lock}
      title={t('lock-state-title-document-history')}
      text={<Trans i18nKey="lock-state-text-document-history" />}
      actions={[
        <Button
          key="upgrade"
          buttonText={t('upgrade-plan')}
          buttonType={ButtonTypes.primaryFilled}
          onClick={() =>
            handleOpenPlanModal(PlanState.Locked, [
              CompanyPlanUpgradeFeatureEnum.Documentation,
            ])
          }
        />,
      ]}
    />
  );
}
